import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "./LotInventoryTable.css"

const LotInventoryTable = () => {
  const { compound_lot_id } = useParams();
  const [rowData, setRowData] = useState([]);
  const subdomain = process.env.REACT_APP_SHADOWSTREAM_SUB || 'genflux';


  useEffect(() => {
    // Fetch data from the server
    axios.get(`https://${subdomain}-server.shadowstream.world/api/lotInventory/getAliquotsForBatchCode/${compound_lot_id}`)
      .then(response => {
        // Convert recordedDate to YYYY-MM-DD format
        const data = response.data.map(item => ({
          ...item,
        //   recordedDate: new Date(item.recordedDate).toISOString().split('T')[0],
          recordedDate: new Date(item.recordedDate).toISOString().replace("T", " ").replace("Z"," (UTC)"),
        }));
        setRowData(data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [compound_lot_id]);

  const columnDefs = [
    { headerName: 'Type', field: 'type', width:150 },
    { headerName: 'Vial Barcode Id', field: 'id', width:150 },
    { headerName: 'Initial Amt', field: 'initialAmount', width:125 },
    { headerName: 'Current Amt', field: 'amount', width:125 },
    // { headerName: 'Units', field: 'amountUnits', width:80 },
    { headerName: 'Inventory Recorded Date', field: 'recordedDate', width:250  },
    { headerName: 'Description', field: 'entry', width:400 },
    { headerName: 'Location', field: 'breadcrumb', width:200 },
  ];

  return (
    <div className="lot-inventory-parent-container">
      <div className="lot-inventory-container">
        <div className="ag-theme-alpine" style={{ height: 600, width:1200, marginBottom:50 }}>
        <div style={{ fontSize:"20px",margin:"10px" }}>Inventory History For {compound_lot_id}</div>

        <AgGridReact
            columnDefs={columnDefs}
            rowData={rowData}
            pagination={true}
            paginationPageSize={10}
        />
        </div>
        </div>
    </div>

  );
};

export default LotInventoryTable;
